<template>
    <div>
        <div class="mcc-page-header">

            <div class="mu-d-flex ">
                <section class="mu-d-flex mu-flex-row ">


                    <h1 class="mu-mb-00">Revision details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>



                </section>
            </div>
            <div>

            </div>

        </div>
        <div class="mcc-container--fluid card-padding">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Administration</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">Audit history</a>
                    </li>
                    <li>Revision</li>
                    <li>{{ revisionNumber }}</li>

                </ol>
            </nav>
            <div class="mcc-card">
                <div class="mcc-card__body">

                    <div class="mcc-card">
                        <div class="mcc-card__header">
                            <h2 class="mcc-card__title">Details</h2>
                        </div>
                        <div class="mcc-card__body">

                            <div class="mcc-row mu-mb-03">
                                <div class="mcc-col">
                                    <span>Modified date</span>
                                </div>
                                <div class="mcc-col">
                                    <span>{{ revisionDate }}</span>
                                </div>
                            </div>
                            <div class="seperator"></div>
                            <div class="mcc-row mu-mt-03">
                                <div class="mcc-col">
                                    <span>Modified by</span>
                                </div>
                                <div class="mcc-col">
                                    <span>{{ modifiedByUser }}</span>
                                </div>
                            </div>


                        </div>

                    </div>


<div class="mcc-card mu-mt-04">
    <div class="mcc-card__body">

                    <div class="mcc-tabs mcc-tabs--compact mcc-tabs--pill">
                        <input type="radio" id="as-default-tab1" name="as-default-tab-control" checked="">
                        <input type="radio" id="as-default-tab2" name="as-default-tab-control">
                        <input type="radio" id="as-default-tab3" name="as-default-tab-control">
                        <ul role="tablist" >
                            <li role="tab">
                                <label for="as-default-tab1" tabindex="0">
                                    <span>Added</span>
                                </label>
                            </li>
                            <li role="tab">
                                <label for="as-default-tab2" tabindex="0">
                                    <span>Modified</span>
                                </label>
                            </li>
                            <li role="tab">
                                <label for="as-default-tab3" tabindex="0">
                                    <span>Deleted</span>
                                </label>
                            </li>
                        </ul>

                        <div role="tabpanel">


                           
                            <div class="mu-mt-05">
                                <div class="mcc-row" v-if="!fetchCall">
                                    <div class="mcc-col colSpinner">
                                        <div class="spinner-overlay">
                                            <div class="spinner-background"></div>
                                            <div class="spinner-flex">
                                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                                    style="width: 48px; height: 48px; ">
                                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20"
                                                        fill="none" stroke-width="5"></circle>
                                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                                    </circle>
                                                </svg>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div  v-if="fetchCall" >
                                  
                                    <mcc-data-table id="addedDataTable"></mcc-data-table>
                                </div>

                            </div>

                        </div>


                        <div role="tabpanel">

                           
                            <div class="mu-mt-05">
                                <div class="mcc-row" v-if="!fetchCall">
                                    <div class="mcc-col colSpinner">
                                        <div class="spinner-overlay">
                                            <div class="spinner-background"></div>
                                            <div class="spinner-flex">
                                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                                    style="width: 48px; height: 48px; ">
                                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20"
                                                        fill="none" stroke-width="5"></circle>
                                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                                    </circle>
                                                </svg>
                                            </div>
                                        </div>

                                    </div>
                                  

                                </div>
                                <div v-if="fetchCall" >
                                   
                                    <mcc-data-table id="modifiedDataTable"></mcc-data-table>
                                </div>

                            </div>


                        </div>
                        <div role="tabpanel">

                           
                            <div class="mu-mt-05">
                                <div class="mcc-row" v-if="!fetchCall">
                                    <div class="mcc-col colSpinner">
                                        <div class="spinner-overlay">
                                            <div class="spinner-background"></div>
                                            <div class="spinner-flex">
                                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                                    style="width: 48px; height: 48px; ">
                                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20"
                                                        fill="none" stroke-width="5"></circle>
                                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                                    </circle>
                                                </svg>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div  v-if="fetchCall" >
                                  
                                    <mcc-data-table id="deletedDataTable"></mcc-data-table>
                                </div>

                            </div>

                        </div>

                   
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import AuditHistoryAPI from "../../../services/AuditHistoryAPI";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    EventBus
} from "../../../services/event-bus";
export default {
    name: "RevisionDetail",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["administration.audithistory.revision.detail"],
            revisionNumber: this.$route.params.revisionNumber,
            modifiedByUser: this.$route.query.modifiedByUser,
            revisionDate: this.$route.query.revisionDate,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            fetchCall: true,
            addedDataList: {},
            noAddedData: true,
            noModifiedData: true,
            noDeletedData: true,
            modifiedDataList: {},
            deletedDataList: {},
            dataLoaded: false,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        AuditHistoryAPI.getTableDataForRevision(this.$route.params.revisionNumber)
            .then(result => {
                if (result == null) {
                    return;
                }
                self.addedDataList = result.addedEntityList;
                if (result.addedEntityList.length > 0) {
                    self.noAddedData = false;
                }

                self.modifiedDataList = result.modifiedEntityList;
                if (result.modifiedEntityList.length > 0) {
                    self.noModifiedData = false;
                }

                self.deletedDataList = result.deletedEntityList;
                if (result.deletedEntityList.length > 0) {
                    self.noDeletedData = false;
                }

                self.dataLoaded = true;
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.revision.details"] + " - " + this.$route.params.revisionNumber;
                EventBus.$emit("update-pageTitle", pageTitle);
            })
            .finally(() => {
                if (self.dataLoaded) {
                    self.fetchCall = true;
                    self.initAddedTable()
                    self.initModifiedtable()
                    self.initDeletedTable()
                }
            });
    },
    
    methods: {
        initAddedTable(){
        let self = this;
        const table = document.getElementById("addedDataTable");
            window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<span class="text-center ">No added history found</span>',
                columnSearch: false,
                pageSize:10,
                fixedHeight:true,
                totalCount: self.addedDataList.length,
                schema: {
                    properties: {
                        entityType: {
                            type: "string",
                            title: "Entity",
                            sortable: true,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor linkCode "  
                            onclick="${() => self.$router.push(self.CONTEXT_PATH + '/admin/audit/entityHistory/' + rowData.entityType)}" >${rowData.entityType}</button>`;
                            },
                            columnSearch: false
                        },
                        id: {
                            type: "string",
                            title: "ID",
                            sortable: true,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor linkCode "  
                            onclick="${() => self.$router.push(self.CONTEXT_PATH + '/admin/audit/entityHistory/' + rowData.entityType + '?entityId=' + rowData.id)}" >${rowData.id}</button>`;
                            },  
                           columnSearch: false
                        },
                        key: {
                            type: "string",
                            title: "Key",
                            sortable: true,
                            columnSearch: false,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor linkCode "  
                            onclick="${() => self.$router.push(self.CONTEXT_PATH + '/admin/audit/entityHistory/' + rowData.entityType + '?entityId=' + rowData.id)}" >${rowData.key}</button>`;
                            },
                        },
                    }
                },
                data: function() {
                const modifiedDataList = self.addedDataList.map(item => {
                    const modifiedItem = {};
                    for (const key in item) {
                        modifiedItem[key] = item[key] === null ? '' : item[key];
                    }
                    return modifiedItem;
                });

                return modifiedDataList;
                }


            })
    },
    initModifiedtable(){
        let self = this;
        const table = document.getElementById("modifiedDataTable");
            window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<span class="text-center ">No modified history found</span>',
                columnSearch: false,
                pageSize:10,
                fixedHeight:true,
                totalCount: self.modifiedDataList.length,
                schema: {
                    properties: {
                        entityType: {
                            type: "string",
                            title: "Entity",
                            sortable: true,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor linkCode "  
                            onclick="${() => self.$router.push(self.CONTEXT_PATH + '/admin/audit/entityHistory/' + rowData.entityType)}" >${rowData.entityType}</button>`;
                            },
                            columnSearch: false
                        },
                        id: {
                            type: "string",
                            title: "ID",
                            sortable: true,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor linkCode "  
                            onclick="${() => self.$router.push(self.CONTEXT_PATH + '/admin/audit/entityHistory/' + rowData.entityType + '?entityId=' + rowData.id)}" >${rowData.id}</button>`;
                            },  
                           columnSearch: false
                        },
                        key: {
                            type: "string",
                            title: "Key",
                            sortable: true,
                            columnSearch: false,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor linkCode " 
                            onclick="${() => self.$router.push(self.CONTEXT_PATH + '/admin/audit/entityHistory/' + rowData.entityType + '?entityId=' + rowData.id)}" >${rowData.key}</button>`;
                            },
                        },
                    }
                },
                data:  function () {
                return self.modifiedDataList;
                }
            })
    },
    initDeletedTable(){
        let self = this;
        const table = document.getElementById("deletedDataTable");
            window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<span class="text-center ">No deleted history found</span>',
                columnSearch: false,
                pageSize:10,
                fixedHeight:true,
                totalCount: self.deletedDataList.length,
                schema: {
                    properties: {
                        entityType: {
                            type: "string",
                            title: "Entity",
                            sortable: true,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor linkCode "  
                            onclick="${() => self.$router.push(self.CONTEXT_PATH + '/admin/audit/entityHistory/' + rowData.entityType)}" >${rowData.entityType}</button>`;
                            },
                            columnSearch: false
                        },
                        id: {
                            type: "string",
                            title: "ID",
                            sortable: true,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor linkCode "  
                            onclick="${() => self.$router.push(self.CONTEXT_PATH + '/admin/audit/entityHistory/' + rowData.entityType + '?entityId=' + rowData.id)}" >${rowData.id}</button>`;
                            },  
                           columnSearch: false
                        },
                        key: {
                            type: "string",
                            title: "Key",
                            sortable: true,
                            columnSearch: false,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor linkCode "  
                            onclick="${() => self.$router.push(self.CONTEXT_PATH + '/admin/audit/entityHistory/' + rowData.entityType + '?entityId=' + rowData.id)}" >${rowData.key}</button>`;
                            },
                        },
                    }
                },
                data:  function () {
                return self.deletedDataList;
                }
            })
    },
        redirectToList() {
            localStorage.setItem("auditList", "auditList");

            this.$router.push(
                this.CONTEXT_PATH + '/admin/audit'
            );
        }
    }
};
</script>
